module.exports = __webpack_public_path__ + "fonts/Calibre-Bold.87cc6590.woff2";